module.exports = {"TXTWCL_Player_Funds_Protection":{"id":"TXTWCL_Player_Funds_Protection","defaultMessage":"Játékostőke védelem"}}